<!-- <mat-spinner *ngIf="!filteredItems"></mat-spinner> -->
<div *ngIf="filteredItems" class="panel">
    <!-- <mat-spinner></mat-spinner> -->
    <mat-grid-list cols="6" rowHeight="23:4" gutterSize="16">
        <mat-grid-tile class="titulo" rowspan="1" colspan="2">
            <div class="div-subtitulo texto-branco">
                <strong>Viagens Interplantas</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile class="titulo" rowspan="1" colspan="2">
            <div class="div-subtitulo texto-branco">
                <strong>Viagens Milk Run </strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile class="titulo" rowspan="1" colspan="2">
            <div class="div-subtitulo texto-branco">
                <strong>Filling Rate</strong>
            </div>
        </mat-grid-tile>

        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Planejadas</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Realizadas</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Planejadas</strong>
            </div>
        </mat-grid-tile>

        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Finalizadas</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Objetivo</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Planejado</strong>
            </div>
        </mat-grid-tile>



        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados planejado">
                <h1>{{ itemsInterplantas.length }}</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile [ngClass]="classInterplantas" rowspan="3" colspan="1">
            <div class="div-dados" (click)="editDialog2(itemsInterplantasAtrasadas)">
                <h1>{{ viagensInterplantasFinalizadas.length }}<span class="complemento">/{{ totalJanelasInterplantasObj }}</span></h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados planejado">
                <h1>{{ MRtotalizado }}</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile [ngClass]="classMR" rowspan="3" colspan="1">
            <div class="div-dados" (click)="editDialog3(viagensMRDeveriamFinalizarNaoFinalizou)">
                <h1>{{ totalMRFinalizado.length }} <span class="complemento">/{{ totalViagensValidas }}</span></h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados  planejado">
                <h1 class="porcentagem-grande">{{ objFillingRate }}%</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile [ngClass]="classFillingRate" rowspan="3" colspan="1">
            <div class="div-dados">
                <h1 class="porcentagem-grande">{{ calcularMediaMaiorValor() }}%</h1>
            </div>
        </mat-grid-tile>

        <!-- ***************************************************************************************************************************************************************** -->


        <mat-grid-tile class="titulo" rowspan="1" colspan="2">
            <div class="div-subtitulo texto-branco">
                <strong>Veículos Grandes</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile class="titulo" rowspan="1" colspan="3">
            <div class="div-subtitulo texto-branco">
                <strong>Cumprimento de Janelas</strong>
            </div>
        </mat-grid-tile>
        <!-- <mat-grid-tile class="titulo" rowspan="2" colspan="1">
            <div class="div-subtitulo texto-branco">
                <strong>Custo Total</strong>
            </div>
        </mat-grid-tile> -->
        <mat-grid-tile class="titulo" rowspan="1" colspan="1">
            <div class="div-subtitulo texto-branco">
                <strong>Eficiência</strong>
            </div>
        </mat-grid-tile>

        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Objetivo</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Planejado</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Objetivo</strong>
            </div>
        </mat-grid-tile>

        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Coleta</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Entrega</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Realizado</strong>
            </div>
        </mat-grid-tile>


        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados  planejado">
                <h1 class="porcentagem-grande">{{ objVeiculosGrandes }}%</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile [ngClass]="classVeiculosGrandes" rowspan="3" colspan="1">
            <div class="div-dados">
                <h1 class="porcentagem-grande">{{ qtdVeiculosGD }}%</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados">
                <h1 class="porcentagem-grande planejado">{{ objJanelas }}%</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile [ngClass]="classJanelasColeta" rowspan="3" colspan="1">
            <div class="div-dados" (click)="editDialog(itemColetados)">
                <h1 class="porcentagem-grande">{{ porcentagemColetaPontual }}%</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile [ngClass]="classJanelasEntrega" rowspan="3" colspan="1">
            <div class="div-dados" (click)="editDialog(itemEntregues)">
                <!-- <h1 class="porcentagem-grande">{{ porcentagemEntregaPontual }}%</h1> -->
                <h1 class="porcentagem-grande">{{ porcentagemEntregaPontual }}%</h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados planejado">
                <h1 class="porcentagem-grande">{{ eficiencia }}%</h1>
            </div>
        </mat-grid-tile>
        <!-- <mat-grid-tile [ngClass]="classJanelasAtrasada" rowspan="1" colspan="1">
        <div class="div-dados">
            <h1 class="porcentagem-pequena">{{ porcentagemAtrasado}}%</h1>
        </div>
    </mat-grid-tile>
    <mat-grid-tile [ngClass]="classJanelasTotal" rowspan="1" colspan="1">
        <div class="div-dados">
            <h1 class="porcentagem-pequena">{{ porcentagemTotal}}%</h1>
        </div>
    </mat-grid-tile> -->
        <!-- <mat-grid-tile rowspan="2" colspan="1">
            <div class="div-dados">
                <h1 class="moeda">{{ calcularSomaCustoViagem() | currency:'BRL' }}</h1>
                <h2>Realizado</h2>
            </div>
        </mat-grid-tile> -->


        <!-- ***************************************************************************************************************************************************************** -->


        <mat-grid-tile class="titulo" rowspan="2" colspan="1">
            <div class="div-subtitulo texto-branco">
                <strong>Peso Total Transportado</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile class="titulo" rowspan="2" colspan="1">
            <div class="div-subtitulo texto-branco">
                <strong>Custo Total</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile class="titulo" rowspan="2" colspan="2">
            <div class="div-subtitulo texto-branco">
                <strong>Distância Total</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile class="titulo" rowspan="2" colspan="2">
            <div class="div-subtitulo texto-branco">
                <strong>Emissão CO2</strong>
            </div>
        </mat-grid-tile>

        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Planejado</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="1">
            <div class="div-subtitulo">
                <strong>Planejado</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="2">
            <div class="div-subtitulo">
                <strong>Planejado</strong>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="1" colspan="2">
            <div class="div-subtitulo">
                <strong>Planejado</strong>
            </div>
        </mat-grid-tile>


        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados planejado">
                <h1 class="moeda">{{ pesoTotalTransportadoMR }} <span class="complemento">TON</span> </h1>
            </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="3" colspan="1">
            <div class="div-dados planejado">
                <h1 class="moeda"><span class="complemento">R$</span> {{ valorTotalTransportadoMR }} <span
                        class="complemento">K</span> </h1>
            </div>
        </mat-grid-tile>
        <!-- <mat-grid-tile rowspan="2" colspan="2">
            <div class="div-dados">
                <h1 class="porcentagem-grande">{{ getPercentComentNotEmpty() }}%</h1>
            </div>
        </mat-grid-tile> -->
        <mat-grid-tile rowspan="3" colspan="2">
            <div class="div-dados planejado">
                <h1 class="porcentagem">{{ distanciaTotal }} <span class="complemento">Km</span> </h1>
            </div>
        </mat-grid-tile>
        <!-- <mat-grid-tile rowspan="2" colspan="1">
            <div class="div-dados">
                <h1 class="porcentagem">{{ somarTotalDistancePercorrida() }}Km</h1>
                <h2>Percorrida</h2>
            </div>
        </mat-grid-tile> -->

        <mat-grid-tile rowspan="3" colspan="2">
            <div class="div-dados">
                <h1 class="porcentagem">{{ emissao }} <span class="complemento">kgCO²e/TON</span></h1>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
</div>

<clr-modal [(clrModalOpen)]="dialogOpen3" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form [formGroup]="form" class="inputs"> 
        <!-- <form class="inputs"> -->
            <table class="table2000">
                <tr *ngFor="let item of itemsApresentarNaoFinalizados; let i = index" class="flexEdit">
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen3" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Placa }}</span>
                    </td>
                    <td>
                        <label class="modal-label">Locais coleta</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen3" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Fornecedores }}</span>
                    </td>
                    <td>
                        <label class="modal-label">Janela de Entrega</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen3" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Janela | date: 'dd/MM/yyyy HH:mm' : '+00:00'  }}</span>                         
                    </td>        
                </tr>
            </table>
        </form>
    </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="dialogOpen2" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form [formGroup]="form" class="inputs"> 
        <!-- <form class="inputs"> -->
            <table class="table2000">
                <tr *ngFor="let item of itemsApresentarInterplantas; let i = index" class="flexEdit">
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen2" [ngClass]="getRowClass(item.PassoEntrega)" class="modal-input99">{{ item.Plate }}</span>
                    </td>
                    <td>
                        <label class="modal-label">Viagem</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen2" [ngClass]="getRowClass(item.PassoEntrega)" class="modal-input99">{{ item.viagem }}</span>
                    </td>
                    <td>
                        <label class="modal-label">Janela</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen2" [ngClass]="getRowClass(item.PassoEntrega)" class="modal-input99">{{ item.Janela | date: 'dd/MM/yyyy HH:mm' : '+00:00' }}</span>                         
                    </td>
                    <!-- <td>
                        <label class="modal-label">Horário Chegada</label>
                    </td>
                    <td class="align-left input-maior">
                            <span *ngIf="dialogOpen2" [ngClass]="getRowClass(item.PassoEntrega)" class="modal-input99">{{ item.Chegada | date:
                                'dd/MM/yyyy HH:mm' }}</span>               
                    </td> -->
                </tr>
            </table>
        </form>
    </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form [formGroup]="form" class="inputs"> 
        <!-- <form class="inputs"> -->
            <table class="table2000">
                <tr *ngFor="let item of itemsApresentar; let i = index" class="flexEdit">
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Placa ? item.Placa : item.Plate }}</span>
                        <!-- <input type="text" formControlName="{{i}}.Placa" [ngClass]="getRowClass(item.Passo)" class="modal-input1"> -->
                        <!-- <input type="string" name="Fornecedor" [(ngModel)]="item.Fornecedor"
                            [ngClass]="getRowClass(item.Passo)" class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Local de entrega</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Fornecedor ? item.Fornecedor : item['Destino 1'] }}</span>
                        <!-- <input type="text" formControlName="{{i}}.Fornecedor" [ngClass]="getRowClass(item.Passo)" class="modal-input1"> -->
                        <!-- <input type="string" name="Fornecedor" [(ngModel)]="item.Fornecedor"
                            [ngClass]="getRowClass(item.Passo)" class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Janela de entrega</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Janela | date: 'dd/MM/yyyy HH:mm' : '+00:00' }}</span>                         
                        <!-- <input type="text" formControlName="{{i}}.Janela" [ngClass]="getRowClass(item.Passo)" class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Horário Chegada</label>
                    </td>
                    <td class="align-left input-maior">
                        <span *ngIf="dialogOpen" [ngClass]="getRowClass(item.Passo)" class="modal-input99">{{ item.Chegada | date:
                            'dd/MM/yyyy HH:mm' }}</span>           
                        <!-- <input type="text" formControlName="{{i}}.Janela" [ngClass]="getRowClass(item.Passo)" class="modal-input1"> -->
                    </td>
                    <!-- <td>
                        <label class="modal-label">Status</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" formControlName="{{i}}.Passo" class="modal-input1">
                    </td> -->
                </tr>
            </table>
        </form>
    </div>
</clr-modal>


<div *ngIf="!filteredItems" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>